import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

function Navbar() {
  const { currentUser, logout } = useAuth();

  return (
    <nav className="navbar">
      <div className="navbar__inner">
        <Link to="/" className="navbar__brand">PlutoCadence</Link>
        <ul className="navbar__links">
          <li><a href="#features">Features</a></li>
          <li><a href="#about">About</a></li>
        </ul>
        <div className="navbar__auth">
          {currentUser ? (
            <>
              <span className="navbar__user-email">{currentUser.email}</span>
              <button className="navbar__signout" onClick={logout}>Sign Out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="navbar__signin">Sign In</Link>
              <Link to="/signup" className="navbar__cta">Get Started</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
